import React from 'react'
import PropTypes from 'prop-types'
import { Table, Label } from 'reactstrap'
import styled from 'styled-components'
import get from 'lodash/get'
import orderBy from 'lodash/orderBy'
import moment from '../../../lib/moment.js'
import shortid from 'shortid'
import arrow_down from '../../../static/images/arrow-down.svg'
import arrow_up from '../../../static/images/arrow-up.svg'
import { compensate_work_header_table } from '../constants'
import { statusColor } from '../helpers/color'
import { FONTS, COLORS } from '../../../constants'

export default class CompensateWorkTable extends React.Component {
  state={ sort_order: false, sort_column: 1 }

  handleClickSort(column) {
    if (column === this.state.sort_column) {
      this.setState({
        sort_order: !this.state.sort_order,
      })
    } else {
      this.setState({
        sort_order: false,
        sort_column: column,
      })
    }
  }

  filterCompensateReport = (compensateReport, searchCompensate) => {
    return compensateReport.filter(item => {
      const emp_code = get(item, 'emp_code', '').toLowerCase()
      const status = get(item, 'status', '').toLowerCase()
      const name = get(item, 'name').toLowerCase()
      const project = get(item, 'project', '').toLowerCase()
      const approver = get(item, 'approver', '').toLowerCase()
      const search = searchCompensate.toLowerCase()
      return status.includes(search) || emp_code.includes(search) || name.includes(search)
        || project.includes(search) || approver.includes(search)
    })
  }

  sortCompensateWork = (data) => {
    const { sort_column } = this.state
    const sort_order = this.state.sort_order ? 'asc' : 'desc'
    if (sort_column === 0) {
      return orderBy(data, (item) => {
        const order = {
          'PENDING': 1,
          'APPROVED': 2,
          'CANCEL': 3,
          'REJECTED': 4,
        }
        return order[item.status]
      }, sort_order)
    } else if (sort_column === 1) return orderBy(data, 'start_date', sort_order)
    else if (sort_column === 2) return orderBy(data, 'end_date', sort_order)
    else if (sort_column === 3) return orderBy(data, 'days', sort_order)
    else if (sort_column === 4) return orderBy(data, 'emp_code', sort_order)
    else if (sort_column === 5) return orderBy(data, 'name', sort_order)
    else if (sort_column === 6) return orderBy(data, 'project', sort_order)
    else if (sort_column === 7) return orderBy(data, 'approver', sort_order)
    return data
  }

  render() {
    const { sort_order, sort_column } = this.state
    const { searchCompensate } = this.props
    let compensateReport = get(this.props, 'compensateReport', [])
    compensateReport = this.filterCompensateReport(compensateReport, searchCompensate)

    return (
    /* eslint no-underscore-dangle: 0 */
      <Wrapper>
        <NewTable bordered hover>
          <Header>
            <tr>
              {
                compensate_work_header_table.map((h) =>
                  (<HeadTable key={ shortid() } onClick={ () => this.handleClickSort(h.value) } >
                    { h.label }
                    { h.value === sort_column && (
                      sort_order && h.value === sort_column ?
                        <Icon src={ arrow_up } alt="logo" />
                        :
                        <Icon src={ arrow_down } alt="logo" />
                    )
                    }</HeadTable>)
                )}
            </tr>
          </Header>
          <BodyTable>
            {
              this.sortCompensateWork(compensateReport).map(report => {
                return (<tr
                  key={ shortid() }
                  style={ {
                    cursor: 'pointer',
                    hover: '#E5E5E5',
                  } }
                  onClick={ () => this.props.handleClickRow(report._id, report) }
                >
                  <td>
                    <div
                      style={ {
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        color: statusColor(report.status),
                      } }
                    >
                      <Circle color={ statusColor(report.status) } />
                      <Text>{ report.status }</Text>
                    </div>
                  </td>
                  <td>{ moment(report.start_date).format('DD/MM/YYYY') }</td>
                  <td>{ moment(report.end_date).format('DD/MM/YYYY') }</td>
                  <td>{ report.days }</td>
                  <td>{ report.emp_code }</td>
                  <td>{ report.name }</td>
                  <td>{ report.project }</td>
                  <td>{ report.approver }</td>
                </tr>)
              }
              )}
          </BodyTable>
        </NewTable>
      </Wrapper>
    )
  }
}

CompensateWorkTable.propTypes = {
  handleClickRow: PropTypes.func,
  searchCompensate: PropTypes.string,
}
CompensateWorkTable.defaultProps = {
  handleClickRow: () => {},
  searchCompensate: '',
}

const Wrapper = styled.div`
  margin-left: 10px;
  margin-right: 10px;
`
const NewTable = styled(Table)`
  background: white;
  thead {
    display: table;
    width: 100%;
    table-layout: fixed;
  } tbody tr {
    display: table;
    width: 100%;
    table-layout: fixed;
    font-family: ${FONTS.GOTHAM} !important;
    font-size: ${FONTS.SMALL_SIZE};
    border: none;
  } thead th {
    border: 1px solid #dee2e6;
    font-size: ${FONTS.SMALL_SIZE};
  } tbody td {
    border: 1px solid #dee2e6;
    font-size: ${FONTS.SMALL_SIZE};
    word-wrap: break-word;
  }
`
const BodyTable = styled.tbody`
  width: 100%;
  display: block;
  max-height: calc(100vh - 200px);
  overflow-y: scroll;
  ::-webkit-scrollbar {
    display: none;
  }
`
const HeadTable = styled.th`
  color: white;
  font-family: ${FONTS.GOTHAM_MEDIUM} !important;
    font-size: ${FONTS.SMALL_SIZE};
  cursor: pointer;
`
const Icon = styled.img`
  height : 10px;
  margin-left: 5%;
  cursor: pointer;
`
const Header = styled.thead`
  background: ${COLORS.TABLE_HEADER_COLOR};
`
const Circle = styled.div`
  height: 8px;
  width: 8px;
  background-color: ${props => { return props.color }};
  border-radius: 50%;
  margin-right: 8px;
`
const Text = styled(Label)`
  margin-bottom: 0px;
`



// WEBPACK FOOTER //
// ./src/components/report/table/compensate-work.js